//###############################################################

// set test/local
export const testURL = "http://localhost:2830";

//###############################################################
// set server
export const baseURL =
  process.env.NODE_ENV != "development"
    ? "https://apimer.comsevencareer.com"
    : testURL;
//###############################################################

export const version = "v1";
export const MobileDevice = /iPhone|iPad|iPod|Android/i.test(
  navigator.userAgent
);

export const NoIpadDevice = /iPhone|iPod|Android/i.test(navigator.userAgent);

import axios from "axios";
import join from "url-join";

const isAbsoluteURLRegex = /^(?:\w+:)\/\//;

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("Token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.request.use(async (config) => {
  if (!isAbsoluteURLRegex.test(config.url)) {
    config.url = join(baseURL, config.url);
  }
  // config.timeout = 10000 // 10 Second
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    } else if (!error.response) {
      return Promise.reject({
        status: 502,
        message: "Bad Gateway : " + error.message,
      });
    }
    return Promise.reject({ status: 9999, message: error });
  }
);

export const HttpClinet = axios;

export const checkEmail = (email) => {
  return email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export function checkPasswordStrength(password) {
  const errors = [];
  const bad_password = ["password"];
  if (bad_password.some((res) => res.toLowerCase() == password.toLowerCase()))
    errors.push("รหัสผ่านของคุณมันง่ายเกินไป");
  if (password.length < 8) errors.push("รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร");
  if (!/[A-Z]/.test(password)) errors.push("ต้องมีตัวพิมพ์ใหญ่");
  if (!/[a-z]/.test(password)) errors.push("ต้องมีตัวพิมพ์เล็ก");
  if (!/[0-9]/.test(password)) errors.push("ต้องมีตัวเลข");
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
    errors.push("ต้องมีอักขระพิเศษ");

  return errors;
}
